import { useCallback, useContext, useEffect } from 'react';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { ChatQueryStatus } from '@trinity/chat';
import { QuerySocketEvent } from '@trinity/chat';
import { useChatQuerySocket } from '@trinity/chat-components/websocket';
import type { WS } from '@trinity/chat';

type Props = {
  children: React.ReactNode;
  queryIdentifier: string;
  queryStatus: ChatQueryStatus;
};

export const QueryFollowupsContainer = (props: Props) => {

  const dispatch = useContext(ChatStateDispatchContext);
  const socket = useChatQuerySocket(props.queryIdentifier);

  const handleFollowupsAvailable = useCallback((data: WS.QueryFollowupsAvailable.Data) => {
    dispatch({
      type: 'query-followups-available',
      payload: {
        queryIdentifier: data.queryIdentifier,
        items: data.items,
      },
    });
  }, [dispatch]);

  useEffect(() => {
    if (!socket) return;

    if (props.queryStatus === ChatQueryStatus.Complete) {
      socket.on(QuerySocketEvent.QueryFollowupsAvailable, handleFollowupsAvailable);
    }

    return () => {
      socket.off(QuerySocketEvent.QueryFollowupsAvailable, handleFollowupsAvailable);
    };
  }, [handleFollowupsAvailable, socket, props.queryStatus]);

  return (
    <>
      {props.children}
    </>
  );
};